'use client';

import * as Sentry from '@sentry/nextjs';
import type { ErrorBoundaryProps } from './types';

export function ErrorBoundary({ tags = {}, ...props }: ErrorBoundaryProps) {
    return (
        <Sentry.ErrorBoundary
            beforeCapture={scope => {
                Object.entries(tags).forEach(([key, value]) => {
                    scope.setTag(key, value);
                });
            }}
            {...props}
        />
    );
}
